export default __webpack_public_path__ + "static/media/available_default_noeld_selected.0fd27445.svg";